import { END_POINT } from "constants/apiConstant";
import { apiGet, apiPost } from "../utils/apiUtils";

const { MAIL_ORDER_EMAIL, MAIL_ORDER_SEND } = END_POINT;

// Fetch the order email configured for the company for this distributor type
// (to pre-fill the draft). type: "Arrow" | "TTI" | "Avnet" | "Rutronik".
export const getMailOrderEmail = async (type) => {
  return await apiGet(`${MAIL_ORDER_EMAIL}?type=${encodeURIComponent(type)}`);
};

// Send the order email with the generated Excel attached.
export const sendMailOrderEmail = async (payload) => {
  return await apiPost(MAIL_ORDER_SEND, payload);
};
